import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Container } from '@mui/material';

export default function CircularIndeterminate () {
    return (
        <Container variant='event-loader-wrapper'>
            <CircularProgress />
        </Container>
    );
}
